import styled from '@emotion/styled'
import Psps from '../../../../assets/psps.png'

export const PspLinks = styled.div`
  background: url(${Psps});
  background-size: contain;
  background-repeat: no-repeat;
  width: 260px;
  height: 33px;
`
